module.exports = __webpack_public_path__ + "assets/img/00042.234c181d.png";